import { useQuery } from '@tanstack/react-query';
import * as personaService from '../services/personaService';

// v0.4 Task 6: shared lookup for DAG rich variants. React-query
// dedupes concurrent fetches for the same id, so a 5-peer fan that
// all render simultaneously fires one request per unique personaId.
// Cached for a long stale time — peer identities don't change mid-
// turn.
export function usePersonaById(personaId: string | null | undefined) {
  return useQuery(
    ['persona', personaId],
    () =>
      personaId
        ? personaService.getPersona(personaId)
        : Promise.reject('no personaId'),
    {
      enabled: !!personaId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      retry: 1,
    },
  );
}
